import { useEffect, useState } from "react";

export const useUserAgent = () => {
  const [userAgent, setUserAgent] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (typeof window !== "undefined" && typeof navigator !== "undefined") {
      setUserAgent(navigator.userAgent);
    }
  }, []);

  return userAgent;
};
